import { highlightGenerationStages, ruleConfigurationUIStepTypes } from "constants/v2/ruleConfigurationConstants";

export const ruleFilterTypes = {
  status: "status",
  stepType: "stepType",
  rulesOn: "rulesOn",
  triggers: "triggers",
  blocksUsed: "blocksUsed",
  category: "category",
  title: "title",
  executionTime: "executionTime",
  stream: "stream",
  tournament: "tournament",
  tournamentRuleConfigurations: "tournamentRuleConfigurations",
  events: "events",
  eventsRuleConfigurations: "eventsRuleConfigurations",
  clip: "clip",
  players: "players",
  teams: "teams",
  ruleId: "ruleId",
};

export const ruleConfigurationSearchTypes = {
  ruleTitle: "Rule Title",
  email: "Email",
};

export const ruleConfigurationSearchOptions = [
  ruleConfigurationSearchTypes.ruleTitle,
  ruleConfigurationSearchTypes.email,
];

export const ruleExecutionSearchTypes = {
  executionMessage: "Execution Message",
  streamName: "Stream Name",
};

export const ruleExecutionSearchOptions = [
  ruleExecutionSearchTypes.executionMessage,
  ruleExecutionSearchTypes.streamName,
];

export const stepStatusAPIResponseTypes = {
  Succeeded: "succeeded",
  Errored: "errored",
  Failed: "failed",
};

export const stepStatusTypes = {
  Succeeded: "Succeeded",
  Errored: "Errored",
  Failed: "Failed",
};

export const mapStepTypeToIcon = {
  [ruleConfigurationUIStepTypes.send_mail]: "components/v2/RuleConfigurationDetails/RuleOutputCard/mail.svg",
  [ruleConfigurationUIStepTypes.filters]: "components/v2/RuleConfigurationDetails/RuleOutputCard/publish.svg",
  [ruleConfigurationUIStepTypes.cloud_publish]: "components/v2/RuleConfigurationDetails/RuleOutputCard/publish.svg",
};

export const imageAllowedStepTypes = [
  highlightGenerationStages.highlight_generated,
  highlightGenerationStages.save_as_clip,
  highlightGenerationStages.add_to_highlight,
  ruleConfigurationUIStepTypes.highlight_generation,
];

export const tabNames = {
  RuleConfigurations: "RuleConfigurations",
  RuleExecutions: "RuleExecutions",
};

export const lastExecutedUIList = {
  fifteenMinutes: "15m",
  oneHour: "1hr",
  fourHours: "4hr",
  oneDay: "1d",
  twoDays: "2d",
  threeDays: "3d",
  oneWeek: "1w",
  fifteenDays: "15d",
  oneMonth: "1mo",
};

export const PUBLISH_TAB_NAMES = {
  successfulPublish: "successfulPublish",
  failedPublish: "failedPublish",
  generated: "generated",
};

export const DEFAULT_RULE_EXECUTION_TIME_PERIOD = lastExecutedUIList.oneMonth;
